<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <MyForm ref="form" :form="form" :rules="rules1" :labelWidth="labelWidth" :formGroups="formGroups"
      :viewMode="viewMode">
    </MyForm>

    <div class="btns">
      <SubmitBtn v-if="mode != 'view'" :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <CancelBtn :mode="mode" @onCancel="cancel"></CancelBtn>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import staffDetailMixin from "../mixin/detail";

export default {
  name: "TempDriverDetail",
  mixins: [detailMixin, staffDetailMixin],
  data() {
    return {
      baseUrl: 'shortdriver',
      breadcrumb: [
        { name: "人员管理", path: "/staff/tempDriver" },
        { name: "打短司机管理", path: "/staff/tempDriver" },
        { name: "添加打短司机" },
      ],
      rules1: {
        name: [
          { required: true, message: "请填写姓名", trigger: "blur" },
        ],
        tel: [
          { required: true, validator: this.checkPhone, trigger: "blur" },
        ],
      },
    };
  },
  methods: {},
  created() {
    this.formGroups.length = 1
    this.formGroups[0].formCtrl.splice(3, 2)
    this.formGroups[0].formCtrl.push({
      label: "驾驶证正反面",
      keyName: "driverslicense",
      type: "file",
      tips: "最多上传2张图片",
      max: 2,
      className: "block",
    })
    this.formGroups[0].formCtrl.push({
      label: "驾驶员从业资格证正反面",
      keyName: "certificate",
      type: "file",
      tips: "最多上传2张图片",
      max: 2,
      className: "block",
    })
    this.getOptions();
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.btns {
  margin: 40px 0 60px 180px;
}
</style>
